import React from 'react';
import { localizationService } from '@shared-services/localization-service';
import { Booking } from '../../types';
import DateAndTimeIcon from '../icons/DateAndTimeIcon';
import { BookingDataView, BookingDataViewType } from './BookingDataView';
import { getConfirmationString } from './strings';


export const getConfirmationPendingString = (key: string) => {
    return localizationService.str(
        `ui.runtimessr.calbooking.confirmation.pending.${key}`
    );
};

interface BookingConfirmationPendingProps {
    confirmationData: Booking;
    closeConfirmation: () => void;
    rescheduleBooking: () => void;
    setCancelBookingId: (bookingId: string) => void;
}

const BookingConfirmationPending = ({
    confirmationData,
    closeConfirmation,
    rescheduleBooking,
    setCancelBookingId,
}: BookingConfirmationPendingProps) => (
    <BookingDataView
        bookingData={confirmationData}
        dataAuto='booking-confirmation-pending-screen'
        onClose={closeConfirmation}
        type={BookingDataViewType.PENDING}
        title={getConfirmationPendingString('title')}
        subtitle={getConfirmationPendingString('subtitle')}
        svgIcon={<DateAndTimeIcon />}
    >
        <label>{getConfirmationString('change')}</label>
        <span onClick={rescheduleBooking}>
            {getConfirmationString('reschedule')}
        </span>
        <label>{getConfirmationString('or')}</label>
        <span
            onClick={() => {
                setCancelBookingId(confirmationData.uid);
                closeConfirmation();
            }}
        >
            {getConfirmationString('cancel')}
        </span>
    </BookingDataView>
);

export default BookingConfirmationPending;
